var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-step"},[_c('div',{staticClass:"header"},[_c('span',{staticClass:"header-text"},[_vm._v(_vm._s(_vm.t('Step {0}',[_vm.step])))])]),_c('div',{staticClass:"step-indicator"},_vm._l((_vm.count),function(i){return _c('div',{key:i,staticClass:"step-indicator-shard",class:{
        'empty': _vm.step < i
      }})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }